export default __webpack_public_path__ + "static/media/flipkart.3f4a4d6d.png";